// @flow
import React, { useCallback, useState } from 'react'

import PlainButton from 'app/common/ui-next/plain-button'
import PlainConfirmModal from 'app/common/ui-next/plain-confirm-modal'
import { DotsLoader } from 'app/common/components/Loader'
import { PlainPopupIdToClipboard } from 'app/common/ui-next/plain-popup-clipboard'
import PlainButtonAsLink from 'app/common/ui-next/plain-button-as-link'
import type { ComplexLastChange } from 'app/common/types/food/schools/complexes/history'
import { ComplexHistoryLink } from '../ComplexHistoryLink'

import styles from './DishesKitSimple.scss'

type Props = {
  orgId: number,
  id: number,
  title: string,
  cost: string,
  lastChange?: ComplexLastChange,
  loading: boolean,
  onRestore: (id: number, title: string) => Promise<boolean>,
}

const DishesKitSimple = ({ orgId, id, title, cost, lastChange, loading, onRestore }: Props) => {
  const [confirmationVisible, setConfirmationVisible] = useState(false)
  const [restoring, setRestoring] = useState(false)

  const handleCancel = useCallback(() => {
    setConfirmationVisible(false)
  }, [])

  const handleConfirmation = useCallback(() => {
    setConfirmationVisible(true)
  }, [])

  const handleRestore = useCallback(async () => {
    setRestoring(true)
    setConfirmationVisible(false)
    await onRestore(id, title)
    setRestoring(false)
  }, [onRestore, id, title])

  return (
    <div className={styles.root}>
      {loading && <div className={styles.blockedWhileLoaded} />}

      {loading && <DotsLoader className={styles.loader} />}

      <div className={styles.details}>
        <div className={styles.header}>
          <PlainPopupIdToClipboard id={String(id)}>
            {(onClick) => (
              <PlainButtonAsLink onClick={onClick} className={styles.headerTitle}>
                {title}
              </PlainButtonAsLink>
            )}
          </PlainPopupIdToClipboard>
          <div className={styles.headerCost}>{cost}</div>
        </div>
        <ComplexHistoryLink
          className={styles.historyLink}
          orgId={orgId}
          complexId={id}
          complexTitle={title}
          lastChange={lastChange}
        />
      </div>

      <PlainButton onClick={handleConfirmation} disabled={loading || restoring}>
        {restoring ? 'Восстановление...' : 'Восстановить'}
      </PlainButton>

      {confirmationVisible && (
        <PlainConfirmModal
          messageText={`Вы уверены, что хотите восстановить комплект «${title}»?`}
          cancelButtonTitle="Отмена"
          confirmButtonTitle="Восстановить"
          onCancel={handleCancel}
          onConfirm={handleRestore}
        />
      )}
    </div>
  )
}

export default DishesKitSimple
